import { secured } from '../plugins/axios';

const resource = '/notifications/admin';

export default {
    notificationsList: params => secured.get(`${resource}/notifications/`, { params }),
    broadcastNotification: payload => secured.post(`${resource}/notifications/broadcast/`, payload),

    notificationTypesList: () => secured.get(`${resource}/notification-types/`),
    fcmDevicesList: () => secured.get(`${resource}/fcm-devices/`),
};
